const CLIENT_ENVS: { [key: string]: string | undefined } = {
  REACT_APP_API_URL: process.env.REACT_APP_API_URL,
  REACT_APP_ADMIN_API_URL: process.env.REACT_APP_ADMIN_API_URL,
};

const getEnvironmentVariable = (environmentVariable: string): string => {
  const unValidatedEnvironmentVariable =
    process.env[environmentVariable] || CLIENT_ENVS[environmentVariable];

  if (!unValidatedEnvironmentVariable) {
    throw new Error(
      `Couldn't find environment variable: ${environmentVariable}`
    );
  } else {
    return unValidatedEnvironmentVariable;
  }
};

/**
 * 환경변수가 없으면 빈 문자열 반환 (선택적 환경변수용)
 */
const getOptionalEnvironmentVariable = (
  environmentVariable: string
): string => {
  return (
    process.env[environmentVariable] ||
    CLIENT_ENVS[environmentVariable] ||
    ""
  );
};

const config = {
  apiUrl: getEnvironmentVariable("REACT_APP_API_URL"),
  adminApiUrl: getEnvironmentVariable("REACT_APP_ADMIN_API_URL"),
};

export default config;
